import { render } from "./TitlePanel.vue?vue&type=template&id=487ca74b&scoped=true"
import script from "./TitlePanel.vue?vue&type=script&lang=js"
export * from "./TitlePanel.vue?vue&type=script&lang=js"

import "./TitlePanel.vue?vue&type=style&index=0&id=487ca74b&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487ca74b"]])

export default __exports__